import { localStorage } from 'dibs-browser-storage';

const HAS_SEEN_FAVORITES_TOOLTIP = 'HAS_SEEN_FAVORITES_TOOLTIP';

export function hasSeenFavoritesTooltip() {
    return localStorage.getItem(HAS_SEEN_FAVORITES_TOOLTIP) || false;
}

export function logFavoritesTooltipView() {
    localStorage.setItem(HAS_SEEN_FAVORITES_TOOLTIP, true);
}

export const FORCE_FAVORITE_ITEM_ID = 'FORCE_FAVORITE_ITEM_ID';
export const FORCE_FOLDER_ITEM_ID = 'FORCE_FOLDER_ITEM_ID';

export function getForceFavoriteItemId(key) {
    return localStorage.getItem(key);
}

export function setForceFavoriteItemId(key, itemId) {
    localStorage.setItem(key, itemId);
}

export function clearForceFavoriteItemId(key) {
    localStorage.deleteItem(key);
}
